import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class StoresOrdersApiService extends ApiService {
  static endpoint = 'stores';

  /**
   * @param {String|Number} url
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @public
   */
  static async get(url, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(url), {
      ...config,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} url
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @public
   */
  static async post(url, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(url), data, {
      ...config,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
